module.exports = __webpack_public_path__ + "static/media/EditDoneIcon.3f17d6ed.svg";